import { SensitivitySection } from 'components/shared/Sensitivity/SensitivitySection/SensitivitySection';
import { connect } from 'react-redux';
import type { WorkspaceTabOwnProps } from 'shared/connect/connect';
import type { Metric } from 'state/quotes/details/details.model';
import { getFormQuoteDetails } from 'state/selectors/common/commonForm';
import { hasMetrics } from 'state/selectors/meta/quote/utils';
import type { AppState } from 'state/state.model';
import { getUserPreferencesMetricsPrecision } from 'state/userPreferences/userPreferences.selectors';

interface MetricsProps {
  hasMetrics: boolean;

  metrics?: Readonly<Metric[]>;

  precisionMetrics?: number;
}

const mapStateToProps = (state: AppState, { formId, workspace }: WorkspaceTabOwnProps): MetricsProps => {
  const quoteDetails = getFormQuoteDetails(state, workspace, formId);
  return {
    hasMetrics: hasMetrics(state, workspace, formId),
    metrics: quoteDetails?.Metrics,
    precisionMetrics: getUserPreferencesMetricsPrecision(state),
  };
};

export const ConnectedMetrics = connect(mapStateToProps)(MetricsSection);

function MetricsSection({ metrics, hasMetrics, precisionMetrics }: MetricsProps) {
  if (!!metrics && hasMetrics) {
    return (
      <SensitivitySection
        sectionName="Metrics"
        unavailableDataMessageKey="quoteDetails.NoMetricsAvailable"
        data={metrics!}
        copyActionName="Copy metrics"
        precision={precisionMetrics ?? 4}
      />
    );
  }
}
